import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dce6222"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\MyCode\\shop\\waynboot-mobile-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dce6222')) {
      api.createRecord('0dce6222', component.options)
    } else {
      api.reload('0dce6222', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dce6222", function () {
      api.rerender('0dce6222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImagePic/index.vue"
export default component.exports